import { render, staticRenderFns } from "./e-phone.vue?vue&type=template&id=d4c86fb6&scoped=true&"
import script from "./e-phone.vue?vue&type=script&lang=js&"
export * from "./e-phone.vue?vue&type=script&lang=js&"
import style0 from "./e-phone.vue?vue&type=style&index=0&id=d4c86fb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c86fb6",
  null
  
)

export default component.exports